// src/guards/AuthGuard.tsx

import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useEffect, useState } from 'react';
import { authService } from '../services/auth';

interface Props {
  children: React.ReactNode;
}

export const AuthGuard = ({ children }: Props) => {
  const { isAuthenticated, refreshTokens } = useAuth();
  const [isChecking, setIsChecking] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAndRefreshToken = async () => {
      try {
        const accessToken = authService.getAccessToken();
        const refreshToken = authService.getRefreshToken();

        if (!accessToken && !refreshToken) {
          setIsChecking(false);
          return;
        }

        if (authService.isAccessTokenExpired() && !authService.isRefreshTokenExpired()) {
          await refreshTokens();
        }
      } catch (error) {
        console.error('Token refresh failed:', error);
      } finally {
        setIsChecking(false);
      }
    };

    checkAndRefreshToken();
  }, [refreshTokens]);

  if (isChecking) {
    return null; // или компонент загрузки
  }

  if (!isAuthenticated && !isChecking) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
